import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { PracticeReseveContext } from '../../PracticeReseveContext';
import Modal from '../../../../common/Modal';
import PracticeReserveSituationModal from './modal/PracticeReserveSituationModal';

import {
  PracticeReserveSituationDisplaySituations,
  PracticeReserveSituationValue,
  PracticeReserveSituationItem,
} from '../../../../../models/practice/reserve/situation/PracticeReserveSituation';


function PracticeReserveSituation() {

  const { isPc } = useContext(cmnContext);
  const {
    isLesson, displaySituations, selectedSituation,
  } = useContext(PracticeReseveContext);

  const [dispSitucation, setDispSituation] = useState<string>('');
  // モーダル表示
  const [isDispModal, setIsDispModal] = useState<boolean>(false);


  // 選択時にモーダルを閉じる
  useEffect(() => {
    setIsDispModal(false);
  }, [selectedSituation])


  // 実践内容
  useEffect(() => {
    if (!displaySituations) return;
    for (const situation of displaySituations as PracticeReserveSituationDisplaySituations) {
      const valueMap: PracticeReserveSituationValue = situation.value;
      for (const key in valueMap) {
        const category: PracticeReserveSituationItem = valueMap[key];
        if (category.id === selectedSituation) {
          setDispSituation(category.situation);
        }
      }
    }
  }, [displaySituations, selectedSituation]);


  return (
    <>
    {isLesson &&
      <>
        <div style={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '20px',
        }}>

          <div>
            <label className="control-label" htmlFor="contact-birth" style={{
              backgroundColor: '#eaf3ff',
              padding: '0.25em 3em 0.25em 0.5em',
              borderLeft: 'solid 5px #516ab6',
            }}>実践したい内容</label>

            <div style={{marginLeft: '5px'}}>
              <p style={{
                margin: 0,
                fontSize: '16px',
                // バリデーションStyle
                ...(!selectedSituation ? 
                  {
                    backgroundColor: 'red',
                    color: '#fff',
                    padding: '3px 10px',
                  }
                  : {}
                )
              }}>
                {(dispSitucation) ?
                  <>{dispSitucation}</>
                :
                  <>内容を選んでください</>
                }
              </p>
            </div>
          </div>

          <div style={{marginRight: isPc? '5px':0}}>
            <button
              type="button"
              className='btn btn-primary'
              style={{
                width: '100%',
                margin: isPc? '10px 0 5px 5px' : '5px 0 5px 5px',
              }}
              onClick={() => setIsDispModal(true)}
            >
              {(selectedSituation)? '選び直す' : '内容を選ぶ' }
            </button>
          </div>

        </div>

        {/* 選択モーダル */}
        <Modal
          comp={<PracticeReserveSituationModal />}
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          isDispClose={true}
        />
      </>
    }
    </>
  );
}
  
export default PracticeReserveSituation;